// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";

function Block(Props) {
  var blockInfo = Props.blockInfo;
  return React.createElement("div", {
              id: "block"
            }, React.createElement("div", {
                  className: "info"
                }, blockInfo.blockHash, React.createElement("div", undefined, "hash")), React.createElement("div", {
                  className: "info"
                }, blockInfo.blockNumber, React.createElement("div", undefined, "Block number")), React.createElement("div", {
                  className: "info"
                }, blockInfo.stateRoot, React.createElement("div", undefined, "State root")), React.createElement("div", {
                  className: "info"
                }, blockInfo.extrinsicsRoot, React.createElement("div", undefined, "Extrinsics root")), React.createElement("div", {
                  className: "info"
                }, blockInfo.parentHash, React.createElement("div", undefined, "Parent hash")));
}

var make = Block;

export {
  make ,
  
}
/* react Not a pure module */
